<template>
  <div class="container-custom moo-sheet-page moo-tier-page" :style="styleObject">
    <div class="content-custom">
      <div class="moo-sheet-shell">
        <MooSheetHead
          icon="workspace_premium"
          title="Loyalty tier benefit"
          @close="goBack()"
        />

        <div v-if="isLoadDone && isLogined">
          <template v-if="tiers.length">
            <!-- Stepper: every tier, the achieved ones filled. Tapping one
                 switches which tier's detail is shown, same as the member site. -->
            <div class="tb-steps-scroll" ref="stepsScroll">
              <div class="tb-steps">
                <template v-for="(tier, index) in tiers" :key="tier.id">
                  <div class="tb-step-line" v-if="index > 0"></div>
                  <button
                    type="button"
                    class="tb-step"
                    :class="{ 'tb-step--selected': tier.id === selectedTier.id }"
                    :ref="tier.is_current_tier ? 'currentStep' : undefined"
                    @click="selectTier(tier)"
                  >
                    <span
                      class="tb-step__circle"
                      :class="isAchieved(index) ? 'tb-step__circle--done' : 'tb-step__circle--todo'"
                    >
                      {{ index + 1 }}
                    </span>
                    <span
                      class="tb-step__label"
                      :class="isAchieved(index) ? 'tb-step__label--done' : 'tb-step__label--todo'"
                    >
                      {{ tier.tier_name }}
                    </span>
                  </button>
                </template>
              </div>
            </div>

            <div
              class="tb-tier-card"
              :class="{ 'tb-tier-card--current': selectedTier.is_current_tier }"
            >
              <div class="tb-tier-card__info">
                <div class="tb-tier-card__name">{{ selectedTier.tier_name }} tier</div>
                <div class="tb-tier-card__note" v-if="selectedTier.is_current_tier">
                  You are currently in this tier
                </div>
                <div
                  class="tb-tier-card__note"
                  v-else-if="selectedTier.show_tier_condition && selectedTier.note_text"
                >
                  {{ selectedTier.note_text }}
                </div>
              </div>
              <div class="tb-tier-card__badge">
                <img
                  v-if="selectedTier.tier_badge_url"
                  :src="selectedTier.tier_badge_url"
                  alt="tier"
                />
                <span
                  v-if="selectedTier.is_current_tier"
                  class="material-icons-round tb-tier-card__check"
                  >check_circle</span
                >
              </div>
            </div>

            <template v-if="selectedTier.show_tier_description && selectedTier.description">
              <div class="tb-section-title">Description</div>
              <div class="tb-card">
                <p class="tb-card__line">{{ selectedTier.description }}</p>
              </div>
            </template>

            <template v-if="showCondition">
              <div class="tb-section-title">Condition</div>
              <div class="tb-card">
                <p class="tb-card__line" v-for="(line, index) in conditions" :key="index">
                  {{ line.text }}
                  <span class="tb-chip" v-if="line.completed">Completed</span>
                </p>
              </div>
            </template>

            <button
              v-if="canActivate && isEligible"
              type="button"
              class="tb-activate"
              @click="gotoGetMemberShip()"
            >
              <span class="material-icons-round">workspace_premium</span>
              Activate this membership
            </button>
            <div class="tb-locked" v-else-if="canActivate && !eligibilityPending">
              <span class="material-icons-round tb-locked__icon">lock</span>
              <div>
                <div class="tb-locked__title">Not available yet</div>
                <div
                  class="tb-locked__reason"
                  v-for="(reason, index) in ineligibleReasons"
                  :key="index"
                >
                  {{ reason }}
                </div>
              </div>
            </div>

            <template v-if="benefits.length">
              <div class="tb-section-title">Benefit</div>
              <div class="tb-benefits">
                <div class="tb-benefit" v-for="(benefit, index) in benefits" :key="index">
                  <span class="material-icons-round tb-benefit__icon">check</span>
                  <div class="tb-benefit__body">
                    <div class="tb-benefit__title">{{ benefit.title }}</div>
                    <div
                      class="tb-benefit__desc"
                      v-for="(line, i) in benefit.lines"
                      :key="i"
                    >
                      {{ line }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>

          <div class="tb-empty" v-else>
            <span class="material-icons-outlined">workspace_premium</span>
            <span>No tier yet!</span>
          </div>
        </div>
      </div>
    </div>

    <ModalSuccess
      :processAcction="closeSuccessModal"
      :success="true"
      :message="successMessage"
      buttonText="Done"
    />

    <GuestRewardPrompt
      :show="showGuestPrompt"
      @signin="gotoSignInFromGuestPrompt()"
      @dismiss="goBack()"
    />

    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialLoading from "@/components/MaterialLoading.vue";
import MooSheetHead from "@/components/MooSheetHead.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import GuestRewardPrompt from "@/components/GuestRewardPrompt.vue";
import ModalSuccess from "@/components/ModalSuccess.vue";
import $ from "jquery";
import MemberService from "../services/member.service";
import { tierConditions, tierBenefits } from "@/config/tier";
import {
  localStorageName,
  gotoMemberLogin,
  checkTierAchieveConditions,
} from "@/config/utils";

export default {
  name: "LoyaltyTierBenefit",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    GuestRewardPrompt,
    ModalSuccess,
    MooSheetHead,
  },
  data() {
    return {
      isLogined: false,
      isLoadDone: false,
      showGuestPrompt: false,
      branchCode: "",
      tableCode: "",
      pathType: "",
      tiers: [],
      selectedTier: {},
      // merchant_member carries share_info_profile and
      // already_achieved_a_paid_tier_previously, the two member-side halves of
      // the tier conditions.
      merchantMember: {},
      // Tiers and merchant_member load in parallel; until the member half has
      // arrived, an empty object reads as "no conditions met" and would flash a
      // wrong lock on a member who does qualify.
      merchantMemberLoaded: false,
      // Captured when the success sheet opens so the message keeps its text
      // while the tier list reloads underneath it.
      activatedTierName: "",
      pendingSuccess: false,
      // The activating job had not reported back by the time the success sheet
      // opened; the receipt says so rather than promising a live tier.
      membershipStillProcessing: false,
      loaderActive: false,
      snackbar: null,
      message: "",
    };
  },
  created() {
    this.pathType = this.$route.params.type;
    this.branchCode = this.$store.state.branchCode;
    this.tableCode = this.$route.params.table_code;

    const memberInfoData = JSON.parse(
      localStorage.getItem(localStorageName("memberInfo")) || "null"
    );
    this.isLogined = !!memberInfoData;

    if (this.isLogined) {
      this.getTiers();
      this.getMemberInfo();
      this.handleMembershipReturn();
    } else {
      this.isLoadDone = true;
      this.showGuestPrompt = true;
    }
  },
  computed: {
    styleObject() {
      // Same base TopUp.vue / MyTransactions.vue drive their tints off.
      return {
        "--color": this.$store.state.mainThemeColorTheme2
          ? this.$store.state.mainThemeColorTheme2
          : this.$store.state.color,
      };
    },
    // Index of the member's own tier — everything up to it counts as achieved.
    currentTierIndex() {
      return this.tiers.findIndex((tier) => tier.is_current_tier);
    },
    // show_tier_condition is a per-tier merchant flag defaulting to 0, so a paid
    // tier usually has it off and rendered nothing at all — yet its fee,
    // spending and duration are exactly what a member needs to decide whether
    // to buy in, precisely while they are NOT in that tier yet.
    successMessage() {
      const note = this.membershipStillProcessing
        ? `<span class="ps-note">${this.$t("membership.stillProcessing")}</span>`
        : "";

      return `
        <span class="ps-title">Membership Activated</span>
        <span class="ps-amount">${this.activatedTierName}</span>
        <span class="ps-rows">
          <div class="ps-row">
            <span class="material-icons-outlined ps-row-icon">workspace_premium</span>
            <span class="ps-row-label">Your tier</span>
            <span class="ps-row-value">${this.activatedTierName}</span>
          </div>
        </span>
        ${note}
      `;
    },
    // Paying must not bypass the tier's "Condition to achieve tier" (spending,
    // share full profile, already achieved a paid tier). Evaluated in the app —
    // see checkTierAchieveConditions for what that costs in accuracy.
    eligibilityPending() {
      return !this.merchantMemberLoaded;
    },
    eligibility() {
      return checkTierAchieveConditions(this.selectedTier, this.merchantMember);
    },
    isEligible() {
      return !this.eligibilityPending && this.eligibility.eligible;
    },
    ineligibleReasons() {
      return this.eligibility.reasons;
    },
    // A paid tier the member is not on yet is the only one worth buying.
    canActivate() {
      const tier = this.selectedTier;
      return !!tier && tier.is_paid_member_ship == 1 && !tier.is_current_tier;
    },
    showCondition() {
      const tier = this.selectedTier;
      return (
        !!tier &&
        !!(tier.show_tier_condition || tier.is_paid_member_ship) &&
        this.conditions.length > 0
      );
    },
    conditions() {
      return tierConditions(this.selectedTier);
    },
    benefits() {
      return tierBenefits(this.selectedTier);
    },
  },
  methods: {
    // With the strip scrollable, a member on a late tier would otherwise open
    // the screen looking at tier 1.
    // GetMemberShip.vue sends both payment paths back here. The wallet path
    // arrives already settled; the card paths carry a gateway id that has to be
    // confirmed first — the tier itself is granted server-side by the webhook,
    // and the check call re-dispatches it if it never landed.
    handleMembershipReturn() {
      const query = this.$route.query;
      if (query.membership !== "success") {
        return;
      }

      if (query.session_id || query.airwallex_intent_id) {
        this.verifyMembershipPayment(
          query.session_id,
          query.airwallex_intent_id
        );
      } else {
        this.showMembershipSuccess();
      }
    },
    // WAIT for the job that actually grants the tier rather than just verifying
    // the payment: the check endpoint only queues that job, so a single
    // isSuccess means "paid", not "activated" — and the sheet went on to name a
    // tier the member did not have yet. Same wait TopUp.vue does.
    async verifyMembershipPayment(stripeId, airwallexIntentId) {
      this.loaderActive = true;

      const outcome = await MemberService.pollPaymentJobStatus(
        stripeId,
        airwallexIntentId
      );

      if (outcome.status === "failed") {
        this.snackbar = "danger";
        this.message = outcome.message;
        this.setTimeOutNotification();
        this.loaderActive = false;
        return;
      }

      // Ran out of window rather than finished: the payment is taken and the
      // job is still coming, so the sheet says so.
      this.membershipStillProcessing = outcome.status === "pending";
      this.showMembershipSuccess();
      this.loaderActive = false;
    },
    // The sheet names the tier, so it has to wait for the tier list. The
    // verification call and getTiers() race, hence the flag rather than opening
    // the modal from whichever finishes first.
    showMembershipSuccess() {
      this.pendingSuccess = true;
      this.openSuccessWhenReady();
    },
    openSuccessWhenReady() {
      if (!this.pendingSuccess || !this.isLoadDone) {
        return;
      }
      this.pendingSuccess = false;
      // Name the tier from the id that was paid for: the webhook granting it
      // may still be in flight, so the member row is not reliable yet.
      const paidTier = this.tiers.find(
        (tier) => tier.id == this.$route.query.tier_id
      );
      this.activatedTierName = paidTier ? paidTier.tier_name : "Paid membership";
      this.$nextTick(() => {
        $(".btn-success-modal").click();
      });
    },
    closeSuccessModal() {
      $("#success-modal .btn-close").click();
      this.$router.replace({ path: this.$route.path, query: {} });
      this.activatedTierName = "";
      this.membershipStillProcessing = false;
      // Re-read: the webhook has had a moment and the member's tier may have
      // moved, which changes the stepper and every condition on screen.
      this.getTiers();
      this.getMemberInfo();
    },
    scrollCurrentStepIntoView() {
      this.$nextTick(() => {
        const step = this.$refs.currentStep;
        const el = Array.isArray(step) ? step[0] : step;
        const scroller = this.$refs.stepsScroll;
        if (!el || !scroller || scroller.scrollWidth <= scroller.clientWidth) {
          return;
        }
        scroller.scrollLeft =
          el.offsetLeft - (scroller.clientWidth - el.offsetWidth) / 2;
      });
    },
    isAchieved(index) {
      return this.currentTierIndex >= 0 && index <= this.currentTierIndex;
    },
    gotoGetMemberShip() {
      this.$router.push({
        name: "GetMemberShip",
        // The tier is already loaded here; handing it over saves the next
        // screen a second tier-info call, which pulls every tier (and the
        // per-tier work behind it) just to read one row.
        state: { tier: JSON.parse(JSON.stringify(this.selectedTier)) },
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
          tier_id: this.selectedTier.id,
        },
      });
    },
    selectTier(tier) {
      this.selectedTier = tier;
    },
    goBack() {
      this.$router.push({
        name: "Profile",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    gotoSignInFromGuestPrompt() {
      this.showGuestPrompt = false;
      gotoMemberLogin("profile", false, "login");
    },
    getMemberInfo() {
      MemberService.getMemberInfo(this.$store.state.merchantCode).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.merchantMember = response.data.data.merchant_member ?? {};
          }
          this.merchantMemberLoaded = true;
        },
        () => {
          // Failed load must not masquerade as "conditions not met" forever.
          this.merchantMemberLoaded = true;
        }
      );
    },
    getTiers() {
      this.loaderActive = true;
      MemberService.getListTier().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.tiers = response.data.data ?? [];
            // Open on the member's own tier, falling back to the first one.
            const current = this.tiers.find((tier) => tier.is_current_tier);
            this.selectedTier = current || this.tiers[0] || {};
            this.scrollCurrentStepIntoView();
            this.openSuccessWhenReady();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.loaderActive = false;
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error?.response?.data?.result?.message ?? "Cannot load tier info";
          this.setTimeOutNotification();
          this.isLoadDone = true;
          this.loaderActive = false;
        }
      );
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
/* Base MOO page shell — same contract TopUp.vue / MyTransactions.vue rely on. */
.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content-custom {
  flex: 1;
  overflow: auto;
}

/* Same color-mix token recipe as TopUp.vue's --tp-* so the screens match. */
.moo-tier-page {
  /* Aliases onto the shared set in assets/css/moo-sheet.css so the
     colour recipe lives in exactly one place. */
  --tb: var(--sheet);
  --tb-08: var(--sheet-08);
  --tb-12: var(--sheet-12);
  --tb-border: var(--sheet-border);
  --tb-inset: var(--sheet-inset);
}



/* The strip scrolls instead of forcing the whole page sideways once a merchant
   has more tiers than fit (6 x 74px already overflows the 440px shell). The
   inner flex needs min-width: min-content — a centred flex that overflows its
   scroller is otherwise unreachable at its start edge, which clipped the first
   tier. Negative margins let it bleed to the shell edges so a partly visible
   next step signals that it scrolls. */
.tb-steps-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 -20px 22px;
  padding: 0 20px;
  /* Overlay scrollbars only; the peeking step is the affordance here. */
  scrollbar-width: none;
}
.tb-steps-scroll::-webkit-scrollbar {
  display: none;
}
.tb-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: min-content;
}
.tb-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 74px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.tb-step__circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}
.tb-step__circle--done {
  background: var(--tb);
  color: #ffffff;
}
.tb-step__circle--todo {
  background: #ffffff;
  border: 1.5px solid var(--tb-border);
  color: #b8aba0;
}
.tb-step__label {
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  word-break: break-word;
}
.tb-step__label--done {
  font-weight: 700;
  color: #241a12;
}
.tb-step__label--todo {
  color: #857372;
}
.tb-step--selected .tb-step__label {
  color: var(--tb);
  font-weight: 700;
}
.tb-step--selected .tb-step__circle {
  box-shadow: 0 0 0 3px var(--tb-12);
}
.tb-step-line {
  height: 1px;
  flex: 1;
  min-width: 8px;
  margin-top: 16px;
  background: var(--tb-border);
}

.tb-tier-card {
  background: #ffffff;
  border: 1px solid var(--tb-border);
  border-radius: 16px;
  padding: 14px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.tb-tier-card--current {
  border-color: var(--tb);
}
.tb-tier-card__info {
  min-width: 0;
}
.tb-tier-card__name {
  font-size: 14px;
  font-weight: 700;
  color: #241a12;
  text-transform: capitalize;
}
.tb-tier-card__note {
  font-size: 12px;
  color: #857372;
  margin-top: 4px;
}
.tb-tier-card__badge {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.tb-tier-card__badge img {
  width: 34px;
  height: 34px;
  border-radius: 9999px;
  object-fit: contain;
  background: var(--tb-08);
}
.tb-tier-card__check {
  position: absolute;
  right: -4px;
  bottom: -4px;
  font-size: 16px;
  color: var(--tb);
  background: #ffffff;
  border-radius: 9999px;
}

.tb-activate {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  margin-bottom: 20px;
  border: none;
  border-radius: 9999px;
  background: var(--tb);
  color: #ffffff;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.02em;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.tb-activate:active {
  transform: scale(0.98);
}
.tb-activate .material-icons-round {
  font-size: 18px;
}

.tb-locked {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: var(--tb-08);
  border: 1px dashed var(--tb-border);
  border-radius: 16px;
  padding: 14px 16px;
  margin-bottom: 20px;
}
.tb-locked__icon {
  font-size: 18px;
  color: var(--tb);
  flex-shrink: 0;
}
.tb-locked__title {
  font-size: 13px;
  font-weight: 700;
  color: #241a12;
}
.tb-locked__reason {
  font-size: 12px;
  color: #857372;
  margin-top: 3px;
}

.tb-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #241a12;
  margin-bottom: 10px;
}

.tb-card {
  background: #ffffff;
  border: 1px solid var(--tb-border);
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 20px;
}
.tb-card__line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #6b5d55;
  margin: 0 0 6px;
}
.tb-card__line:last-child {
  margin-bottom: 0;
}
.tb-chip {
  font-size: 10.5px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 8px;
  color: var(--tb);
  background: var(--tb-12);
}

.tb-benefits {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tb-benefit {
  display: flex;
  gap: 10px;
}
.tb-benefit__icon {
  font-size: 16px;
  color: var(--tb);
  flex-shrink: 0;
  margin-top: 2px;
}
.tb-benefit__body {
  min-width: 0;
}
.tb-benefit__title {
  font-size: 13px;
  font-weight: 600;
  color: #241a12;
  line-height: 1.5;
}
.tb-benefit__desc {
  font-size: 12px;
  color: #857372;
  line-height: 1.5;
  margin-top: 3px;
}

.tb-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 40px 0;
  color: #857372;
  font-size: 13px;
}
.tb-empty .material-icons-outlined {
  font-size: 28px;
  color: var(--tb-border);
}
</style>
